module.exports = __webpack_public_path__ + "img/green_118.580e2b48.png";